import React, { useEffect, useState } from "react";
import { addSchoolByStudent, getAllCity, getStatus } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { useRef } from "react";
import { toBase64 } from "../../Services/commonHelper";
import { debounce } from "lodash";
import Select from 'react-select';

const AddSchool = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: "",
        name: "",
        city_id: "",
        status: "",
        title: "",
        description: "",
        image: "",
        background_image: "",
        city_name: ""
    });
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState([]);
    const [city, setCity] = useState([]);
    const [previewImage, setPreviewImage] = useState({
        image: "",
        background_image: ""
    });
    const uploadRef = useRef(null);
    const uploadLogoRef = useRef(null);

    const handleChange = (field, value) => {
        if (field == "city_id") {
            setReqData({ ...reqData, [field]: value?.value, city_name: value?.label });
        } else {
            setReqData({ ...reqData, [field]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader("submit");
        const { city_name, ...rest } = reqData;
        let { ok } = await addSchoolByStudent(rest);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const handleImport = async (e, field) => {
        const file = e.target.files[0];
        e.target.value = "";
        if (file?.type?.includes("image/jpeg") || file?.type?.includes("image/png")) {
            let base64String = await toBase64(file);
            handleChange(field, base64String);
            setPreviewImage({ ...previewImage, [field]: URL?.createObjectURL(file) });
        } else {
            toast.error("Image must ba valid .jpeg file")
        }
    };

    const getStatusCall = async () => {
        let { ok, data } = await getStatus({});
        if (ok) {
            setStatus(data?.records);
        }
    };

    const getCityCall = async (search) => {
        setLoader("city");
        let { ok, data } = await getAllCity({ page_number: 0, page_size: 20, search: search || "" });
        if (ok) {
            setCity(data?.records);
        };
        setLoader(false);
    };

    const debouncedFetchData = debounce((inputValue) => {
        getCityCall(inputValue);
    }, 500);

    const handleInputChange = (inputValue) => {
        debouncedFetchData(inputValue);
    };

    useEffect(() => {
        getCityCall();
        getStatusCall();
        if (data?.data) {
            const { id, name, title, description, city_id, image, background_image, status, city_name } = data?.data;
            setReqData({ id, name, title, description, city_id, image, background_image, status, city_name })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add School" : "Edit School"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required
                                                value={reqData?.name}
                                                onChange={(e) => handleChange("name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select required value={reqData?.status} onChange={(e) => handleChange("status", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Status</option>
                                                {status?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>City</label>
                                            <Select
                                                required
                                                value={{ value: reqData?.city_id, label: reqData?.city_name }}
                                                onChange={(e) => { handleChange("city_id", e) }}
                                                onInputChange={handleInputChange}
                                                options={city.map(option => ({ value: option.id, label: `${option.name}, ${option.state_name}, ${option.country_name}` }))}
                                                isLoading={Boolean(loader == "city")}
                                                placeholder="Search..."
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Title"
                                                required
                                                value={reqData?.title}
                                                onChange={(e) => handleChange("title", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Description"
                                                required
                                                value={reqData?.description}
                                                onChange={(e) => handleChange("description", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="mb-3 d-flex bank-details-btn">
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadLogoRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.image ? "Change Image" : "Add Image"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.image || reqData?.image) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Flag Image"
                                                src={previewImage?.image ? previewImage?.image : reqData?.image}
                                            />}
                                        </div>
                                        <div className="mb-3 d-flex bank-details-btn">
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.background_image ? "Change Background" : "Add Background"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.background_image || reqData?.background_image) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Flag Image"
                                                src={previewImage?.background_image ? previewImage?.background_image : reqData?.background_image}
                                            />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader == "submit"}
                                >
                                    {Boolean(loader == "submit") ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <input hidden ref={uploadRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "background_image")} />
            <input hidden ref={uploadLogoRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "image")} />
        </div>
    );
};

export default AddSchool;